/**
 * Created by Reda on 26.08.2024
 */

const OfferButtonComponent = cc.Node.extend({
    ctor: function (options) {
        this.options = options || {};
        const styles = cleverapps.styles.OfferButtonComponent[this.options.offerType] || cleverapps.styles.OfferButtonComponent;
        this._super();
        this.createButton();
        this.setAlignment(styles.position);
    },

    createButton: function () {
        const styles = cleverapps.styles.OfferButtonComponent[this.options.offerType] || cleverapps.styles.OfferButtonComponent;

        const button = this.button = new cleverapps.UI.Button({
            text: this.options.text,
            onClicked: this.options.onClicked,
            height: styles.button.size.height,
            width: styles.button.size.width
        });
        cleverapps.UI.wrapWithPadding(
            button,
            styles.padding || { x: 0, y: 0 },
            true
        );
        button.setAlignment(styles.button.position);
        if (this.options.badgeText) {
            const badge = new TileBadge({
                text: this.options.badgeText,
                rotation: styles.badge.rotation,
                largeFont: styles.badge.largeFont
            });
            badge.setAlignment(styles.badge.position);
            cleverapps.UI.fitToBox(badge, styles.badge.size);
            button.addChild(badge);
        }
        button.setVisible(false);

        this.setContentSize(styles.size);
        this.addChild(button);
    },

    show: function () {
        this.button.stopAllActions();
        StandartAnimations.run("showUp", this.button);
    },

    remove: function () {
        this.button.stopAllActions();

        this.button.runAction(StandartAnimations.disappear(this.button)).setFinalize(() => {
            this.removeFromParent();
        });
    }
});

cleverapps.styles.OfferButtonComponent = {
    position: {
        x: {
            align: "center",
            dx: 0
        },
        y: {
            align: "bottom",
            dy: 30
        }
    },
    button: {
        position: {
            x: {
                align: "center",
                dx: 0
            },
            y: {
                align: "center",
                dy: 0
            }
        },
        size: {
            height: 90,
            width: 500
        }
    },
    padding: {
        x: 50,
        y: 50
    },
    size: {
        height: 150,
        width: 600
    },
    badge: {
        position: {
            x: {
                align: "right",
                dx: 5
            },
            y: {
                align: "top",
                dy: 10
            }
        },
        size: {
            width: 130,
            height: 130
        },
        largeFont: true,
        rotation: 10
    }
};

cleverapps.styles.OfferButtonComponent[Offers.TYPES.STICKERS_PACK] = cleverapps.overrideStyles(cleverapps.styles.OfferButtonComponent, {
    badge: {
        rotation: 30,
        largeFont: false
    },
    position: {
        x: { align: "center", dx: 0 },
        y: { align: "bottom", dy: -20 }
    }
}, true);

cleverapps.styles.OfferButtonComponent[Offers.TYPES.PINBALL_PACK] = cleverapps.overrideStyles(cleverapps.styles.OfferButtonComponent, {
    badge: {
        rotation: 30,
        largeFont: true
    },
    position: {
        x: {
            align: "center",
            dx: 0
        },
        y: {
            align: "bottom",
            dy: -30
        }
    }
}, true);